import { render, staticRenderFns } from "./AbstractRegister.vue?vue&type=template&id=19acc078&"
import script from "./AbstractRegister.vue?vue&type=script&lang=js&"
export * from "./AbstractRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports